// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"392":"804a4f1f71c85eea","513":"1bf2d9cd7c8b7385","677":"af6bc770ff4f576a"}[chunkId] + ".js";
};